import { motion } from "motion/react";
import React, { RefObject, useRef } from "react";
import { useResizeObserver } from "usehooks-ts";

export const FluidContainerHeight = ({ children }: { children: React.ReactNode }) => {
	const ref = useRef<HTMLDivElement>(null);
	const { height = 0 } = useResizeObserver({
		ref: ref as RefObject<HTMLElement>,
		box: "border-box",
	});
	return (
		<motion.div animate={{ height }} transition={{ duration: 0.15, ease: "easeOut" }}>
			<div ref={ref}>{children}</div>
		</motion.div>
	);
};
